import React, { Component } from 'react';
import PropTypes from 'prop-types';

// lodash utils
import uniq from 'lodash/uniq';
import isEmpty from 'lodash/isEmpty';
import lastIndexOf from 'lodash/lastIndexOf';

import FormSimpleToggle from './form-simple-toggle';

class FormGroupToggle extends Component {
  constructor() {
    super();
    this.SELECTED_VALUES_DELIMETER = ',';
  }

  componentWillUpdate(props) {
    const selectedValues = props.selectedValues;
    if (selectedValues !== undefined) {
      const options = selectedValues.split(this.SELECTED_VALUES_DELIMETER);
      if (isEmpty(selectedValues)) {
        return;
      }

      for (let i = 0; i < options.length; i += 1) {
        this.setChecked(options[i], true);
      }
    }
  }

  setChecked = (value, isChecked) => {
    let selectedValues = [];
    if (!isEmpty(this.props.selectedValues)) {
      selectedValues = this.props.selectedValues.split(
        this.SELECTED_VALUES_DELIMETER
      );
    }

    if (isChecked) {
      selectedValues.push(value);
      selectedValues = uniq(selectedValues);
    } else {
      selectedValues = selectedValues.filter(
        currentVal => currentVal !== value
      );
    }

    return selectedValues;
  };

  handleChange = (name, value, isChecked) => {
    this.props.onChange(name, value, isChecked);
  };

  isChecked(value) {
    if (undefined === this.props.selectedValues) {
      return false;
    }

    const selectedValues = this.props.selectedValues.split(
      this.SELECTED_VALUES_DELIMETER
    );

    return selectedValues.includes(value);
  };

  render() {
    return (
      <div className="form-group-toggle">
        {this.props.options.map(option => (
          <FormSimpleToggle
            key={option.id}
            id={option.id}
            cy={option.cy}
            value={option.value}
            label={option.label}
            icon={option.icon}
            checked={this.isChecked(option.value)}
            onChange={this.handleChange}
            tracking={option.tracking}
          />
        ))}
      </div>
    );
  }
}

FormGroupToggle.defaultProps = {
  selectedValues: ''
};

FormGroupToggle.propTypes = {
  selectedValues: PropTypes.string,
  options: PropTypes.array
};

export default FormGroupToggle;
